import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import './donutWorkload.css'

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale)

const DonutWorkload = (props) => {
  const { t } = useTranslation()

  const title = props.title
  const data = props.data
  const labels = props.labels
  const coloursForLabels = props.coloursForLabels
  const displayLegend = props.displayLegend

  const sumOfData = data ? data[0] + data[1] + data[2] + data[3] + data[4] + data[5] + data[6] + data[7] : 0

  // doughnutKey changes forces the component with that key to redraw! Occurs on widget resizing
  const doughnutKey = props.doughnutKey

  const handleClickCamembert = (e) => {
    const sectionClicked = labels[e.chart._active[0].index]
    console.debug(".. you've clicked onto portion '" + sectionClicked + "'")
  }

  return (
    <div className='donutChart'>
      <div className='donutTitle'>{title}</div>
      {sumOfData > 0 ? (
        <Doughnut
          key={doughnutKey}
          data={{
            labels: labels,
            datasets: [
              {
                label: t('9500109'),
                data: [data[0], 0, 0, data[3], 0, 0, 0, 0, 0, 0],
              },
              {
                label: t('0LMA106'),
                data: [0, data[1], data[2], 0, data[4], data[5], data[6], data[7], data[8], data[9]],
              },
            ],
          }}
          options={{
            animation: false,
            responsive: true,
            plugins: {
              legend: {
                display: displayLegend,
                position: 'right',
                textAlign: 'left',
              },
            },
            backgroundColor: coloursForLabels,
            hoverOffset: 4,
            onClick: handleClickCamembert,
          }}
          updateMode='resize'
        />
      ) : (
        <div className='nodata'>{t('9500106')}</div>
      )}
    </div>
  )
}

export default DonutWorkload
